import { render, staticRenderFns } from "./InputFormText.vue?vue&type=template&id=888a0b68"
import script from "./InputFormText.vue?vue&type=script&lang=js"
export * from "./InputFormText.vue?vue&type=script&lang=js"
import style0 from "./InputFormText.vue?vue&type=style&index=0&id=888a0b68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports